import script from "./LinkButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"LinkButton.vue"]])

export default __exports__